// ============================================================
// pdfReports.js — Generador de informes PDF (cliente)
// ------------------------------------------------------------
// Carga jsPDF + autoTable bajo demanda desde CDN (mismo patrón
// que la app informe-crm-pdf). No añade dependencias al package.
// Devuelve un Blob + un objeto descriptor para que el chat lo
// renderice como tarjeta de adjunto descargable.
// ============================================================

function loadScript(src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve();
    const s = document.createElement('script');
    s.src = src;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('No se pudo cargar ' + src));
    document.head.appendChild(s);
  });
}

async function ensureJsPdf() {
  if (!window.jspdf) {
    await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
  }
  if (!(window.jspdf && window.jspdf.jsPDF && window.jspdf.jsPDF.API.autoTable)) {
    await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js');
  }
}

// Paleta corporativa Dimoauto
const COLORS = {
  primary: [0, 81, 135],     // #005187
  accent:  [77, 130, 188],   // #4d82bc
  light:   [240, 244, 248],  // #f0f4f8
  text:    [30, 42, 58],     // #1e2a3a
  muted:   [107, 124, 147],  // #6b7c93
};

function header(doc, title, subtitle) {
  const w = doc.internal.pageSize.getWidth();
  doc.setFillColor(...COLORS.primary);
  doc.rect(0, 0, w, 28, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(18);
  doc.text('DIMOAUTO', 14, 13);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  doc.text(title, 14, 21);
  doc.setFontSize(9);
  doc.setTextColor(220, 230, 240);
  doc.text(subtitle, w - 14, 13, { align: 'right' });
  doc.text(
    'Generado ' + new Date().toLocaleString('es-ES'),
    w - 14, 21, { align: 'right' },
  );
}

function footer(doc) {
  const w = doc.internal.pageSize.getWidth();
  const h = doc.internal.pageSize.getHeight();
  const total = doc.internal.getNumberOfPages();
  for (let i = 1; i <= total; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(...COLORS.muted);
    doc.text('Grupo Dimoauto · Centro de Aplicaciones', 14, h - 8);
    doc.text(`Página ${i} de ${total}`, w - 14, h - 8, { align: 'right' });
  }
}

function sectionTitle(doc, text, y) {
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(13);
  doc.setTextColor(...COLORS.text);
  doc.text(text, 14, y);
  doc.setDrawColor(...COLORS.accent);
  doc.setLineWidth(0.6);
  doc.line(14, y + 1.5, 60, y + 1.5);
  return y + 8;
}

function paragraph(doc, text, y) {
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(...COLORS.text);
  const w = doc.internal.pageSize.getWidth() - 28;
  const lines = doc.splitTextToSize(text, w);
  doc.text(lines, 14, y);
  return y + lines.length * 5 + 3;
}

// ---------- Datos de muestra para cada tipo de informe ----------
// (Cuando exista backend, estos datos vendrán del agente.)

const SAMPLE_DATA = {
  leads_por_comercial: {
    rows: [
      ['Carlos Martín',    42, 18, 24, '57%'],
      ['Laura González',   38, 21, 17, '55%'],
      ['Miguel Garrido',   35, 12, 23, '34%'],
      ['Ana Pérez',        31, 14, 17, '45%'],
      ['Javier Romero',    27, 9,  18, '33%'],
      ['Sara Lozano',      24, 11, 13, '46%'],
    ],
    head: [['Comercial', 'Total', 'Convertidos', 'En curso', 'Conversión']],
  },
  embudo_marketing: {
    rows: [
      ['Google Ads',  1280, 184, 42, '23%', '€ 2.140'],
      ['Meta Ads',     980, 142, 31, '22%', '€ 1.690'],
      ['Web orgánico', 612,  78, 19, '24%', '€ 0'],
      ['Email mkt',    310,  44, 12, '27%', '€ 95'],
    ],
    head: [['Canal', 'Visitas', 'Leads', 'Convertidos', 'Conv.', 'Inversión']],
  },
  costes_mensual: {
    rows: [
      ['OpenAI',           '€ 184,20', '€ 250',  '74%', 'OK'],
      ['n8n Cloud',        '€  48,00', '€  60',  '80%', 'OK'],
      ['Supabase Pro',     '€  25,00', '€  25',  '100%', 'En límite'],
      ['Hetzner CPX31',    '€  18,50', '€  30',  '62%', 'OK'],
      ['Coolify (self)',   '€   0,00', '€   0',  '–',    'OK'],
      ['Anthropic API',    '€  92,40', '€ 150',  '62%',  'OK'],
    ],
    head: [['Servicio', 'Gastado', 'Presupuesto', '% uso', 'Estado']],
  },
  actividad_autoleads: {
    rows: [
      ['Carnovo',       86, 79, 7,  '91%'],
      ['CUSTOMER OPEL', 54, 51, 3,  '94%'],
      ['CUSTOMER PEU',  47, 44, 3,  '93%'],
      ['Coches.net',    38, 34, 4,  '89%'],
      ['Web Dimoauto',  29, 28, 1,  '96%'],
    ],
    head: [['Origen', 'Recibidos', 'Asignados', 'Pendientes', '% éxito']],
  },
  generico: {
    rows: [
      ['Leads totales del mes',          '283'],
      ['Leads convertidos',              '94'],
      ['Tasa de conversión',             '33,2%'],
      ['Inversión en marketing',         '€ 3.925'],
      ['Coste por lead',                 '€ 13,87'],
      ['Comerciales activos',            '6'],
    ],
    head: [['Métrica', 'Valor']],
  },
};

const TITLES = {
  leads_por_comercial: 'Informe · Leads por Comercial',
  embudo_marketing:    'Informe · Embudo de Marketing',
  costes_mensual:      'Informe · Costes Mensuales',
  actividad_autoleads: 'Informe · Actividad AutoLeads',
  generico:            'Informe · Resumen General',
};

const DESCRIPTIONS = {
  leads_por_comercial:
    'Ranking del equipo comercial con leads recibidos, convertidos, en curso y % de conversión. Periodo: últimos 30 días.',
  embudo_marketing:
    'Embudo de adquisición por canal: visitas, leads generados, conversiones y coste asociado. Periodo: mes en curso.',
  costes_mensual:
    'Consumo de servicios respecto al presupuesto definido en costes-app. Las alertas se disparan al superar el 80%.',
  actividad_autoleads:
    'Estado del sistema AutoLeads: leads recibidos por origen, asignados correctamente y pendientes de revisión.',
  generico:
    'Resumen ejecutivo de los KPIs principales del Grupo Dimoauto para el periodo en curso.',
};

// ---------- Generador principal ----------

export async function generateReport(typeId) {
  await ensureJsPdf();
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });

  const type = SAMPLE_DATA[typeId] ? typeId : 'generico';
  const title = TITLES[type];
  const desc  = DESCRIPTIONS[type];
  const data  = SAMPLE_DATA[type];

  header(doc, title, 'Grupo Dimoauto');

  let y = 38;
  y = sectionTitle(doc, 'Resumen', y);
  y = paragraph(doc, desc, y);

  y += 3;
  y = sectionTitle(doc, 'Datos', y);

  doc.autoTable({
    head: data.head,
    body: data.rows,
    startY: y,
    margin: { left: 14, right: 14 },
    headStyles: {
      fillColor: COLORS.primary,
      textColor: [255, 255, 255],
      fontStyle: 'bold',
      fontSize: 10,
    },
    bodyStyles: {
      fontSize: 9.5,
      textColor: COLORS.text,
    },
    alternateRowStyles: { fillColor: COLORS.light },
    styles: { cellPadding: 3 },
  });

  const afterTable = doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : y + 60;
  let yy = afterTable;
  if (yy > 250) { doc.addPage(); yy = 30; }

  yy = sectionTitle(doc, 'Notas', yy);
  yy = paragraph(
    doc,
    'Datos extraídos del Centro de Aplicaciones del Grupo Dimoauto. Para validar o profundizar en cualquier métrica accede a la app correspondiente (CRM, Marketing, Control de Gastos).',
    yy,
  );

  footer(doc);

  const blob = doc.output('blob');
  const filename =
    'informe_' + type + '_' + new Date().toISOString().slice(0, 10) + '.pdf';
  const url = URL.createObjectURL(blob);
  return { blob, url, filename, sizeKb: Math.round(blob.size / 1024) };
}

// ---------- Generador desde spec real del asesor ----------
// Recibe el JSON del bloque dimo-report (datos consultados en vivo):
//   { title, subtitle, sections: [ { heading, text, table:{head,rows} } ] }

function slugify(s) {
  return (s || 'dimoauto')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, 40) || 'dimoauto';
}

export async function generateReportFromSpec(spec) {
  await ensureJsPdf();
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });

  const title = (spec && spec.title) || 'Informe Dimoauto';
  header(doc, title, 'Grupo Dimoauto');

  let y = 38;
  if (spec && spec.subtitle) {
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS.muted);
    doc.text(String(spec.subtitle), 14, y);
    y += 8;
  }

  const sections = Array.isArray(spec && spec.sections) ? spec.sections : [];
  for (const s of sections) {
    if (y > 255) { doc.addPage(); y = 30; }
    if (s.heading) y = sectionTitle(doc, String(s.heading), y);
    if (s.text) y = paragraph(doc, String(s.text), y);
    if (s.table && Array.isArray(s.table.head) && Array.isArray(s.table.rows)) {
      doc.autoTable({
        head: s.table.head,
        body: s.table.rows,
        startY: y,
        margin: { left: 14, right: 14 },
        headStyles: {
          fillColor: COLORS.primary,
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          fontSize: 10,
        },
        bodyStyles: { fontSize: 9.5, textColor: COLORS.text },
        alternateRowStyles: { fillColor: COLORS.light },
        styles: { cellPadding: 3 },
      });
      y = doc.lastAutoTable ? doc.lastAutoTable.finalY + 8 : y + 40;
    }
    y += 3;
  }

  if (!sections.length) {
    y = paragraph(doc, 'El asesor no devolvió datos estructurados para este informe.', y);
  }

  footer(doc);

  const blob = doc.output('blob');
  const filename =
    'informe_' + slugify(title) + '_' + new Date().toISOString().slice(0, 10) + '.pdf';
  const url = URL.createObjectURL(blob);
  return { blob, url, filename, sizeKb: Math.round(blob.size / 1024) };
}

// ---------- Generador desde la respuesta Markdown del asesor ----------
// Convierte cualquier respuesta (con secciones, tablas y viñetas) en PDF.

function stripInline(s) {
  return (s || '')
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
}

export async function generateReportFromMarkdown(markdown, titleArg, meta) {
  await ensureJsPdf();
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });

  const lines = (markdown || '').split('\n');
  const firstLine = lines.find((l) => l.trim()) || 'Informe Dimoauto';
  const title = titleArg || stripInline(firstLine).slice(0, 70);
  header(doc, title, 'Grupo Dimoauto');

  let y = 38;
  let i = 0;
  while (i < lines.length) {
    const t = (lines[i] || '').trim();

    if (t.startsWith('|')) {
      const rows = [];
      while (i < lines.length && lines[i].trim().startsWith('|')) {
        const r = lines[i].trim();
        const isSep = r.includes('-') && /^\|?[\s:|-]+\|?$/.test(r);
        if (!isSep) {
          let c = r;
          if (c.startsWith('|')) c = c.slice(1);
          if (c.endsWith('|')) c = c.slice(0, -1);
          rows.push(c.split('|').map((x) => stripInline(x.trim())));
        }
        i += 1;
      }
      if (rows.length) {
        if (y > 248) { doc.addPage(); y = 30; }
        doc.autoTable({
          head: [rows[0]],
          body: rows.slice(1),
          startY: y,
          margin: { left: 14, right: 14 },
          headStyles: { fillColor: COLORS.primary, textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 9.5 },
          bodyStyles: { fontSize: 9, textColor: COLORS.text },
          alternateRowStyles: { fillColor: COLORS.light },
          styles: { cellPadding: 2.5 },
        });
        y = doc.lastAutoTable ? doc.lastAutoTable.finalY + 6 : y + 40;
      }
      continue;
    }

    if (y > 275) { doc.addPage(); y = 30; }
    if (t === '') { y += 3; i += 1; continue; }
    if (/^#{1,3}\s/.test(t)) { y = sectionTitle(doc, stripInline(t.replace(/^#{1,3}\s/, '')), y + 2); i += 1; continue; }
    if (/^\*\*[^*]+\*\*$/.test(t)) { y = sectionTitle(doc, stripInline(t), y + 2); i += 1; continue; }
    if (/^[-*]\s+/.test(t)) { y = paragraph(doc, '•  ' + stripInline(t.replace(/^[-*]\s+/, '')), y); i += 1; continue; }
    y = paragraph(doc, stripInline(t), y);
    i += 1;
  }

  if (meta) {
    if (y > 262) { doc.addPage(); y = 30; }
    y += 3;
    const f = (meta.fuentes && meta.fuentes.length ? meta.fuentes.join(', ') : 'CRM');
    y = paragraph(doc, 'Fuentes: ' + f + '  ·  ' + (meta.count || 0) + ' consulta(s) de solo lectura  ·  ' + (meta.snapshot || ''), y);
  }

  footer(doc);
  const blob = doc.output('blob');
  const filename = 'asesor_' + slugify(title) + '_' + new Date().toISOString().slice(0, 10) + '.pdf';
  const url = URL.createObjectURL(blob);
  return { blob, url, filename, sizeKb: Math.round(blob.size / 1024) };
}
